// utils/verifyJwt.ts
import { jwtVerify, createRemoteJWKSet, type JWTVerifyResult } from 'jose';

const JWKS_URL =
  import.meta.env.VITE_JWKS_URL ||
  `${import.meta.env.VITE_API_BASE_URL || 'http://localhost'}/.well-known/jwks.json`;

let jwks: ReturnType<typeof createRemoteJWKSet> | null = null;

const failureReason = (err: unknown): string => {
  if (err instanceof Error) {
    return err.message;
  }

  return typeof err === 'string' ? err : 'non-Error rejection';
};

export const verifyJwt = async (token: string): Promise<JWTVerifyResult | null> => {
  try {
    if (!jwks) {
      jwks = createRemoteJWKSet(new URL(JWKS_URL));
    }

    const result = await jwtVerify(token, jwks, {
      algorithms: ['RS256'],
      clockTolerance: 30,  // seconds — covers normal NTP drift
    });

    return result;
  } catch (err) {
    console.error('JWT verification failed:', failureReason(err));
    return null;
  }
};
